
export default {
  components: {},
  props: {
    time: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      showTime: "",
      count: null,
      timer: null
    }
  },
  computed: {},
  watch: {
    time: {
      handler(newVal) {
        this.count = newVal
      },
      immediate: true
    },
    count: {
      handler(newVal) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        if (newVal <= 0) {
          this.showTime = ""
          clearTimeout(this.timer)
          return
        }
        this.showTime = this.contDownFun(newVal)
        this.timer = setTimeout(() => {
          this.count = this.count - 1000
          this.$emit("curCount", this.count)
          this.showTime = this.contDownFun(this.count)
        }, 1000)
      },
      immediate: true
    }
  },
  created() {
    // this.count = this.time
  },
  mounted() {},
  methods: {
    contDownFun(time) {
      let formateStr = ""
      const lastTime = Math.floor(time / 1000)
      const hour = Math.floor(lastTime / 3600)
      const minute = Math.floor((lastTime - 3600 * hour) / 60)
      const second = lastTime % 60
      const hourTen = Math.floor(hour / 10)
      const hourUnit = hour % 10
      const minuteTen = Math.floor(minute / 10)
      const minuteUnit = minute % 10
      const secondTen = Math.floor(second / 10)
      const secondUnit = second % 10

      if (hourUnit > 0) {
        formateStr = `${hourTen}${hourUnit}:${minuteTen}${minuteUnit}:${secondTen}${secondUnit}`
      } else {
        formateStr = `${minuteTen}${minuteUnit}:${secondTen}${secondUnit}`
      }
      return formateStr
    }
  }
}
